import { lazyLoad } from 'utils/loadable';

export const CatalogType = lazyLoad(
  () => import('./catalogType.page'),
  (module) => module.CatalogType
);
